import React from "react";
import { Input, Button } from "antd";
import { MailOutlined } from "@ant-design/icons";

interface Step1Props {
  email: string;
  setEmail: (value: string) => void;
  onSubmit: () => void;
  loading: boolean;
  onBackToSignIn: () => void;
}

export const Step1: React.FC<Step1Props> = ({
  email,
  setEmail,
  onSubmit,
  loading,
  onBackToSignIn,
}) => {
  return (
    <div>
      <div className="mb-4">
        <Input
          autoFocus
          size="middle"
          type="email"
          value={email}
          placeholder="Email Address"
          onChange={(e) => setEmail(e.target.value)}
          prefix={<MailOutlined />}
          onKeyDown={(e) => {
            if (e.key === "Enter") onSubmit();
          }}
        />
      </div>

      <div className="flex justify-between items-center mb-6">
        <Button
          type="link"
          className="p-0 text-xs text-blue-600"
          onClick={onBackToSignIn}
        >
          Back to Sign In
        </Button>
      </div>

      <Button
        type="primary"
        block
        size="middle"
        loading={loading}
        onClick={onSubmit}
        disabled={!email}
      >
        Send OTP
      </Button>
    </div>
  );
};
